$(document).ready(function(){
	if(!document.querySelector('.common-sign-in-area')) return false;
	
	// LGEUK-124 Start
	var countryCode = $('html').data('countrycode').toUpperCase();
	var cookieA = false;
	
	if(typeof ePrivacyCookies!='undefined' && ePrivacyCookies.get('LGCOM_ADVERTISING')){ // LGEITF-182
		cookieA = true;
	}
	console.log('treasuredata cookie flag : '+cookieA);
	if(cookieA){
		$('head').append('<!-- Treasure Data --><script type="text/javascript">!function(t,e){if(void 0===e[t]){e[t]=function(){e[t].clients.push(this),this._init=[Array.prototype.slice.call(arguments)]},e[t].clients=[];for(var r=function(t){return function(){return this["_"+t]=this["_"+t]||[],this["_"+t].push(Array.prototype.slice.call(arguments)),this}},s=["blockEvents","unblockEvents","setSignedMode","setAnonymousMode","resetUUID","addRecord","fetchGlobalID","set","trackEvent","trackPageview","trackClicks","ready"],n=0;n<s.length;n++){var c=s[n];e[t].prototype[c]=r(c)}var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=("https:"===document.location.protocol?"https:":"http:")+"//cdn.treasuredata.com/sdk/2.2/td.min.js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)}}("Treasure",this);</script>');
	}	
	// LGEUK-124 End
	
	// PJTGPEMP-1 Start
    var user_exist = getParameterByName("user_exist");
    var user_expire = getParameterByName("user_expire");
    if(user_exist == 'true'){
    	$('.lgaccount-user-exist').show().siblings().hide();
    	$('#modal_user_exist').modal('show');
    } else if(user_expire == 'true'){
    	$('.lgaccount-user-expire').show().siblings().hide();
    	$('#modal_user_exist').modal('show');
    }
    // PJTGPEMP-1 End
	
	
	var sgin = {
		el: document.getElementById('signinForm'), // form
		accountErrMsg: document.querySelector('.incorrect-account'),
		cookieName: 'LG5_RememberAccount',
		cookieCheckbox: null,
		accountMail: null,
		hasCaptcha: false,
		submitData: null,
		submitInput: $('#signinForm').find('[name="submitData"]'),
		captchaflagUrl: "",
		captchaWrapObj: null,
		wrongCount: null,

		init: function(){
			// VN language set
			sgin.vnLangCheck();
			sgin.accountMail = $(sgin.el).find('input.email').get(0);
			sgin.cookieName += "_" + $('html').data("countrycode") || "";
			sgin.cookieCheckbox = $(sgin.el).find('input.remember-account').get(0);
			sgin.addEvent();
			sgin.getCookie();

			// captcha fn added
			sgin.captchaflagUrl = $(sgin.el).data("captchaflagUrl");
			sgin.captchaBoxWrap = $(sgin.el).find("#captcha-box-wrap");
			sgin.captchaContainer = $(sgin.el).find(".captcha-area-con");
			sgin.askCaptcha();
		},
		vnLangCheck: function(){
			// VN korean check
			var lang = $('html').attr('lang');
			if (countryCode == 'VN' && lang == 'KR'){
				$(sgin.el).append( '<input type="hidden" name="langType" value="kr">' );
			}
		},
		askCaptcha: function( showErrorCbFn ){
			if(!sgin.captchaflagUrl) return false;
			if (typeof showErrorCbFn !== 'function'){
				showErrorCbFn = new Function();  // jshint ignore:line
			}

			$.ajax({
				type: "post",
				url: sgin.captchaflagUrl,
				async: !1,
				dataType: "json",
				xhrFields: {
					withCredentials: true
				},
				success: function(data) {
					console.log(data);
					//$(sgin.el).attr("data-action-url", data.captchaUrl).data("actionUrl", data.captchaUrl);
					if (!!data.captchaHtml){
						sgin.createCaptcha(data.captchaHtml);
						sgin.captchaContainer.addClass('active');
						sgin.hasCaptcha = true;
					}
					// show error
					showErrorCbFn();
				},
				error: function(request,status,error) {
					console.log("status: "+status);
					console.log("error: "+error);
				}
			});
		},

		showError: function(_t, _target, _msg){
			var block = $(_t).parents(".field-block");
			block.addClass('error').find(_target).text(_msg).show().siblings().hide();
			$(_t).focus();
		},

		getCookie: function(){
			var ac = getCookie(sgin.cookieName);
			if(ac !== undefined) {
				sgin.cookieCheckbox.checked = true;
				sgin.accountMail.value = ac;
			}
		},
		bakeCookie: function(){
			// 20200325 START 김우람 || 쿠키제어 삭제 
			if(sgin.cookieCheckbox.checked) {
				// bake account cookie
				var ac = xssfilter($(sgin.el).find('input.email').get(0).value);
				setCookie(sgin.cookieName, ac);
				//$.cookie(sgin.cookieName, encodeURIComponent(ac), {expires:30});
			}else {
				removeCookie(sgin.cookieName);
			}



		},
		beforeSubmit: function(e){
			e.preventDefault();
			
			// ajax validation
			// LGECI-541 start
			if($(sgin.el).checkValidation()) {
				var result = false;
				if(document.getElementById('customizedCaptcha') ==  null || document.getElementById('customizedCaptcha') == undefined){
					if( !!$('#g-recaptcha').val()){
						// LGEITF-564 start
						//formSubmit();
						reload_recaptcha_wrapper();
			        	setTimeout(formSubmit, 500);	
			        	// LGEITF-564 end
					}else{
						formSubmit();
					}
				}else{
					if(window.captcha && !window.captcha.validation()){
						return false;
					}else{
						formSubmit();
					}
				}
			}    
			
			var submitted = false; /* LGEITF-588 */
            function formSubmit(){
				var actionUrl = $(sgin.el).data("actionUrl");
				var submitInput = $(sgin.el).find('[name="submitData"]');
				
				var userData;
				
				var formSerializeArray = $('#signinForm').serializeArray();
				var object = {};
				for (var i = 0; i < formSerializeArray.length; i++){
					object[formSerializeArray[i].name] = formSerializeArray[i].value;
				}
				object.emailAddr = xssfilter( $('#txtBoxEmail').val() );
				object.password = xssfilter( $('#txtBoxPassword').val() );
				// LGEITF-182 Start
				object["treasureType"] = "login";
				object["tdloginType"] = "normal";
				// LGEITF-182 End
				var signinData = JSON.stringify(object);
				//console.log(signinData);
				$('body').trigger('ajaxLoadBefore');
				// PJTGPEMP-1 Start
				$.ajax({
					type: "post",
					url: actionUrl,
					data: object,
					async: false,
					xhrFields: {
						withCredentials: true
					},
					dataType: "json",
					success: function(data) {
						sgin.submitData = data;
						submitInput.val( JSON.stringify( data ) );
						console.log('signin before submit-----------------------------------------------');
						// 보안상 콘솔 제거
//						console.log(data); // LGEITF-182
						
						if ( data.result ){
							
							//userData = data.data.user;
							// LGECO-230 Start
							if ( data.error.code == '1010' ){
								if (data.privacyData.needOptUpdateFlag == 'N') {
									//$('.field-chk').hide();
									$('.privacy-form-area').removeClass('active');
								} 
								
								$('#modal_update_personal_info').modal();
							// LGECO-230 End	
							} else if ( data.error.code == '1008' ){	
								$('#privacy-again').modal();
							} else if(data.empData!=null && data.empData.newTermsFlag == 'Y'){
								setCookie('empSessionId', data.empData.loginsessionid, true);
								setCookie('newTermsStr', data.empData.newTermsStr, true);
								$('#modal_emp-policy span.modalEmail').html(sgin.accountMail.value);
								$('#modal_emp-policy .modal-form-area .error-msg').hide();
								$('#modal_emp-policy').modal('show');
							} else{
								// adobe
								adobeTrackEvent('sign-in-submit', {login_type : "id_password", page_event : {sign_in : true}});
								// LGEGMC-3469 Start
								if(salesForceUseFlag || salesForceUseFlagV2){ // LGEGMC-5141
									console.log('ecrmLogined insert');
									SalesforceInteractions.sendEvent({
										interaction: {
											name: 'ecrmLogined',
											eventType: 'ecrmLogined',
											ecrmUserId: data.lgeId,
											ecrmLocaleCode: data.countryCode,
											ecrmHostType: deviceTypeComm() // LGEITF-900
										}
									})
								};
								// LGEGMC-3469 End
								sgin.bakeCookie();
								
								// LGEUK-124 Start
								setTimeout(function() {
									//LGEGMC-4064 start TreasureDataInsert 스크립트로 인해 조건변경
									if(cookieA && treasureDataFlag == 'Y'){ // LGEITF-182, LGCOMITF-123
										treasuredataInit(data, 'signInNomalSubmit');
									}else{
										//LGCOMITF-123-2 start
										if ( cookieA ) {
											nonTreasureDataInsertTable(data);
										}
										//LGCOMITF-123-2 end
										sgin.el.submit();
									}
									//LGEGMC-4064 start
									console.log('-----------------------------------------------signin submit');
								}, 100);
								// LGEUK-124 End
								
								submitted = true; /* LGEITF-588 */
							}
							$(sgin.accountErrMsg).removeClass("show");
						} else {
							// validation fail
							// LGECI-541 start
							if(document.getElementById('customizedCaptcha') ==  null || document.getElementById('customizedCaptcha') == undefined){
								if( !!$('#g-recaptcha').val()){
									reload_recaptcha_wrapper();
								}
							}
							// LGECI-541 end
							
							// LGEITF-182, LGEGMC-4064 Start > TreasureDataInsert 스크립트로 인해 조건변경
							if(cookieA && treasureDataFlag == 'Y'){ // LGCOMITF-123
								var tdFailUrl = '/'+countryCode.toLowerCase()+'/my-lg/api/treasureDataFail.lgajax';
								if(window.location.href.indexOf('/oauth/') >=0) {
									var actionURL = ($(sgin.el).data('action-url').length>0) ? $(sgin.el).data('action-url') : null;
									if(actionURL.indexOf('wdev50.lg.com')>=0) {
										tdFailUrl="https://wdev50.lg.com"+tdFailUrl;
									} else if(actionURL.indexOf('wwwstg.lg.com')>=0) {
										tdFailUrl="https://wwwstg.lg.com"+tdFailUrl;
									} else if(actionURL.indexOf('www.lg.com')>=0){
										tdFailUrl="https://www.lg.com"+tdFailUrl;
									}else{
										tdFailUrl="https://"+window.location.host+tdFailUrl;
									}
								}
								
								$.ajax({
								    type: 'post',
								    url: tdFailUrl,
								    dataType: 'json',
								    data: object,
								    xhrFields: {
										withCredentials: true
									},
								    async: false,
								    success: function(failData) {
								    	if(data.error.tdMessage){
								    		failData["failMessage"]=data.error.tdMessage;
								    	}else{
								    		failData["failMessage"]=data.error.message;
										}
										if(data.error.tdTypeFail){
											failData["tdTypeFail"]=data.error.tdTypeFail;
										}
								    	treasuredataInit(failData,'FAIL');
								    },
								    error: function(request,status,error) {
								        console.log("status: "+status);
								        console.log("error: "+error);
								    }
								});
							//LGCOMITF-123-2 start
							} else if ( cookieA ) {
								var tdFailUrl = '/'+countryCode.toLowerCase()+'/my-lg/api/treasureDataFail.lgajax';
								if(window.location.href.indexOf('/oauth/') >=0) {
									var actionURL = ($(sgin.el).data('action-url').length>0) ? $(sgin.el).data('action-url') : null;
									if(actionURL.indexOf('wdev50.lg.com')>=0) {
										tdFailUrl="https://wdev50.lg.com"+tdFailUrl;
									} else if(actionURL.indexOf('wwwstg.lg.com')>=0) {
										tdFailUrl="https://wwwstg.lg.com"+tdFailUrl;
									} else if(actionURL.indexOf('www.lg.com')>=0){
										tdFailUrl="https://www.lg.com"+tdFailUrl;
									}else{
										tdFailUrl="https://"+window.location.host+tdFailUrl;
									}
								}
								
								$.ajax({
								    type: 'post',
								    url: tdFailUrl,
								    dataType: 'json',
								    data: object,
								    xhrFields: {
										withCredentials: true
									},
								    async: false,
								    success: function(failData) {
								    	if(data.error.tdMessage){
								    		failData["failMessage"]=data.error.tdMessage;
								    	}else{
								    		failData["failMessage"]=data.error.message;
										}
										if(data.error.tdTypeFail){
											failData["tdTypeFail"]=data.error.tdTypeFail;
										}
								    	nonTreasureDataInsertTable(failData);
								    },
								    error: function(request,status,error) {
								        console.log("status: "+status);
								        console.log("error: "+error);
								    }
								});
							}
							// LGEITF-182, LGEGMC-4064 End	//LGCOMITF-123-2 end
							if (data.empData != null && data.empData.errorType != null) {
                                $('#modal_user_exist .modal_desc').siblings().hide()
                                if (data.empData.errorType == 'country') {
                                    $('#modal_user_exist span.modalCountry').html(data.empData.returnMessage)
                                    $('#modal_user_exist .modal_desc .lgaccount-user-error-country').show()
                                } else if (data.empData.errorType == 'mail') {
                                    $('#modal_user_exist .modal_desc .lgaccount-user-error-mail').show()
                                } else if (data.empData.errorType == 'other') {
                                    if(data.empData.errorMessage != null){
                                        $('#modal_user_exist span.errorMessage').html(data.empData.errorMessage)
                                    }
                                    $('#modal_user_exist .modal_desc .lgaccount-user-error-other').show()
                                }
								$('#modal_user_exist').modal('show')
								
                            } else {
								// adobe
								adobeTrackEvent('sign-in-submit', {login_type : "id_password", page_event : {sign_in : true}});

								sgin.bakeCookie();

								sgin.askCaptcha(function(){
									for (var key in data.error) {
										var $field = $(sgin.el).find('input[name="' + key + '"]');
										
										if ($field.length) {
											sgin.showError($field, '.ajax-msg', data.error[key]);
										}
									}
								});
								
								$(sgin.accountErrMsg).addClass("show");
							}
						}
					},
					error: function(request) {
						
					},
					complete: function(){
						$('body').trigger('ajaxLoadEnd');
						/* LGEITF-588 Start */
						if(submitted){
							$('#signinForm .btn-area [name=signinFormTrigger]').prop('disabled', true);
						}
						/* LGEITF-588 End */
					}
				});
			}
			// PJTGPEMP-1 END
            // LGECI-541 end
		},
		addEvent: function(){
			$(sgin.el).on({
				submit: sgin.beforeSubmit
			});

			if ( !!sgin.cookieCheckbox ){
				$(sgin.cookieCheckbox).on('click', function(e){
					// 20200325 START 김우람 || 쿠키제어 삭제 
					/*
					if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_IMPROVEMENTS')) {
						// Cookie 사용 가능 시 실행할 스크립트
					} else {
						// Cookie 사용 불가
						// - click : 고정값
						e.preventDefault();
						ePrivacyCookies.view('click');
						return false;
					}
					*/
				});
			}

			$(sgin.el).on('snsLogin',function(e , submitData){
				//console.log('snsLogin' , arguments );
				sgin.submitData = submitData;
				//userData = submitData.data.user;

				// LGECO-230 Start
				if ( submitData.error.code == '1010' ){
					if (submitData.privacyData.needOptUpdateFlag == 'N') {
						$('.privacy-form-area').removeClass('active');
					}
					
					$('#modal_update_personal_info').modal();
				// LGECO-230 End	
				} else if ( submitData.error.code == '1008' ){	
					$('#privacy-again').modal();
				} else {
					var emailAccount = $(sgin.el).find('[name="emailAddr"]');
					var submitInput = $(sgin.el).find('[name="submitData"]');

					emailAccount.val( sgin.submitData.emailAddr );
					submitInput.val( JSON.stringify( sgin.submitData ) );
					
					// adobe
					adobeTrackEvent('sign-in-submit', {login_type : "id_password", page_event : {sign_in : true}});
					// LGEGMC-3469 Start
					if(salesForceUseFlag || salesForceUseFlagV2){ // LGEGMC-5141
						console.log('ecrmLogined insert');
						SalesforceInteractions.sendEvent({
							interaction: {
								name: 'ecrmLogined',
								eventType: 'ecrmLogined',
								ecrmUserId: autoNvl(submitData.lgeId),
								ecrmLocaleCode: autoNvl(submitData.localeCode),
								ecrmHostType: deviceTypeComm() // LGEITF-900
							}
						})
					};
					// LGEGMC-3469 End
					sgin.bakeCookie();
					setTimeout(function() {
						sgin.el.submit();
					}, 100);
				}

			});

			// PJTGPEMP-1 Start
			var $empModal = $(document.querySelector('#modal_emp-policy')),
			$empForm = $empModal.find('form');

			var empValidationCheck = function (e) {
				e.preventDefault();
				console.log("validation check")
				if ($('#signUp-chk1').is(":checked")) {
					$.ajax({
						type: "post",
						url: $empForm.data('url'),
						async: false,
						cache: false,
						xhrFields: {
							withCredentials: true
						},
						contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
						data: { 'empSessionId': getCookie('empSessionId'), 'newTermsStr': getCookie('newTermsStr') },
						dataType: 'json',
						beforeSend: function (w) {
							$('body').trigger('ajaxLoadBefore');
						},
						success: function (d) {
							console.log("Validaton SUCESSS")
							$('#modal_emp-policy').modal('hide');
							$('#modal_emp-policy .modal-form-area .error-msg').hide();
							$('#signinForm .btn-area [name=signinFormTrigger]').trigger('click');
							$('body').trigger('ajaxLoadEnd');

						},
						error: function (request, status, error) {
							console.log("Validaton Err")
							$('#modal_emp-policy .modal-form-area .error-msg').show();
							$('#modal_emp-policy .modal-form-area .error-msg .invalid').show().siblings().hide();
							//$('body').trigger('ajaxLoadEnd');
						}
					});
				} else {
					$('#modal_emp-policy .modal-form-area .error-msg').show();
					$('#modal_emp-policy .modal-form-area .error-msg .required').show().siblings().hide();
				}
			};
			$empForm.on('submit', empValidationCheck);
			// PJTGPEMP-1 End
			
			$('#privacy-again').on('show.bs.modal', function(){
				$(this).find('.field-chk :checkbox').prop('checked', false).each(function(){
					var checkbox = $(this);
					if ( sgin.submitData.privacyData[ checkbox.attr('name') ] === "Y" ){
						checkbox.prop('checked', true);
					}
				});
				// 20200818 LGESG-105
				if ( COUNTRY_CODE === 'sg' ) {
					$('#privacyAgain-chk1, #privacyAgain-chk2').prop('checked',true);
				}
			});

			$('#privacy-again').on('hidden.bs.modal', function(){
				location.reload();
			});
			
			$('#privacyAgainForm [type="submit"]').on('click', function(e){
				e.preventDefault();

				if ( $('#privacyAgainForm').checkValidation() ){

					var submitInput = $(sgin.el).find('[name="submitData"]');

					$('#privacyAgainForm').find('.field-chk :checkbox').each(function(){
						if ( $(this).is(':checked') == true ){
							//console.log('checked checkbox!!!!!!', $(this).attr('id'));
							sgin.submitData.privacyData[ $(this).attr('name') ] = 'on';
						} else {
							sgin.submitData.privacyData[ $(this).attr('name') ] = 'off';
						}
					});
					//console.log('sgin.submitData', sgin.submitData);
					submitInput.val( JSON.stringify( sgin.submitData ) );

					// adobe
					adobeTrackEvent('sign-in-submit', {login_type : "id_password", page_event : {sign_in : true}});
					sgin.bakeCookie();
					setTimeout(function() {
						sgin.el.submit();
					}, 100);
				}
			});
			
			// LGECO-230 Start
			$('#modal_update_personal_info').on('show.bs.modal', function(){
				$(this).find('.field-chk :checkbox').prop('checked', false).each(function(){
					var checkbox = $(this);
					if ( sgin.submitData.privacyData[ checkbox.attr('name') ] === "Y" ){
						checkbox.prop('checked', true);
					}
				});
			});

			$('#modal_update_personal_info').on('hidden.bs.modal', function(){
				location.reload();
			});
			
			$('#privacyNameAgainForm [type="submit"]').on('click', function(e){
				e.preventDefault();

				if ( $('#privacyNameAgainForm').checkValidation() ){

					var submitInput = $(sgin.el).find('[name="submitData"]');

					$('#privacyNameAgainForm').find('.field-chk :checkbox').each(function(){
						if ( $(this).is(':checked') == true ){
							sgin.submitData.privacyData[ $(this).attr('name') ] = 'on';
						} else {
							sgin.submitData.privacyData[ $(this).attr('name') ] = 'off';
						}
					});
					
					$('#privacyNameAgainForm').find('.name-form-area :input[type=text]').each(function() {
						if (!!$(this).val()) {
							sgin.submitData[$(this).attr('name')] = $(this).val();
						}
					});
					
					submitInput.val( JSON.stringify( sgin.submitData ) );

					// adobe
					adobeTrackEvent('sign-in-submit', {login_type : "id_password", page_event : {sign_in : true}});
					sgin.bakeCookie();
					setTimeout(function() {
						sgin.el.submit();
					}, 100);
				}
			});
			// LGECO-230 End
		},
		createCaptcha: function(data){
			sgin.captchaBoxWrap.html(data);
		}
	};

	var fgpw = {
		el: document.getElementById('forgotForm'), // form
		modal: document.getElementById('find_my_password'), // modal popup
		accountMail: null,
		init: function(){
			fgpw.accountMail = $(fgpw.el).find('input.email').get(0);
			fgpw.addEvent();
		},
		beforeSubmit: function(e){
			e.preventDefault();
			// ajax validation
			if($(fgpw.el).checkValidation()){
				if(captcha && captcha.validation()){
					fgpw.el.submit();
				}else if(!captcha){
					fgpw.el.submit();
				}
				
				//Not need ajax.
				// var url = fgpw.el.action;
				// var param = xssfilter($(fgpw.el).serialize());
				// var methodType = $(sgin.el).data('ajaxMethod');
				// ajax.call(url, param, 'json', function(data){
				// 	if(data.result == true){
				// 		$(fgpw.accountMail).parents('.field-block').removeClass('error');
				// 		$(fgpw.modal).find('.msg-box .email').text(fgpw.accountMail.value);
				// 		$(fgpw.modal).modal('show');
				// 	}else {
				// 		$(fgpw.accountMail).parents('.field-block').addClass('error')
				// 			.find('.registered').show().siblings().hide();
				// 	}
				// },methodType);
			}
		},
		addEvent: function(){
			$(fgpw.el).on({
				submit: fgpw.beforeSubmit
			});
			// $(fgpw.el.forgotFormTrigger).on({
			// 	click: fgpw.beforeSubmit
			// });
		}
	};
	sgin.init();
	fgpw.init();
	
	// LGEUK-124 Start 
	// Treasure Data Tracking
	var td_client_id_cookie = '';
	var td_global_id = '';
	var td_ssc_id = '';
	function getCookieTd(name) {
		if ($.cookie(name)) {
			return decodeURIComponent($.cookie(name));
		} else {
			$.cookie(name);
		}
	}
	function treasuredataInit(resultData, type) {
	  	var tdLoginStatus = new Treasure({  // LGEITF-182 
		    host: 'eu01.in.treasuredata.com',
		    writeKey: resultData.apikey,
		    database: resultData.database,
		    sscDomain: 'lg.com',
		    sscServer: 'ssc.lg.com',
		    useServerSideCookie: true
		});

	  	tdLoginStatus.setSignedMode();  // LGEITF-182

		// Enable cross-domain tracking
		tdLoginStatus.set('$global', 'td_global_id', 'td_global_id');  // LGEITF-182

	    var successCallback_ssc = function (serverSideId) {
	    	console.log('successCallback_ssc');
	    	td_ssc_id = serverSideId;
	    	tdLoginStatus.fetchGlobalID(successCallback, errorCallback);  // LGEITF-182
    	};
    	var errorCallback_ssc = function (error) {
		  console.log('errorCallback_ssc :: '+error);
		}
    	tdLoginStatus.fetchServerCookie(successCallback_ssc, errorCallback_ssc);  // LGEITF-182

	    // Receive td_global_id
	    var successCallback = function(td_global_id_data) {

	    	console.log('successCallback');
			td_global_id = td_global_id_data;
			td_client_id_cookie = getCookieTd('_td');
			
			treasuredataAjax(resultData);
		
			// LGEITF-182 Start
			if(type != "FAIL"){
				sgin.el.submit();
			}
			// LGEITF-182 End
	    };
	    var errorCallback = function(err) {
	    	console.log('errorCallback');
			td_client_id_cookie = getCookieTd('_td');
			treasuredataAjax(resultData);
			
			// LGEITF-182 Start
			if(type != "FAIL"){
				sgin.el.submit();
			}
			// LGEITF-182 End
	    };

	    // Track pageview information to 'TABLE_NAME' table
			
	}

	function treasuredataAjax(resultData){
		var treasuredataUrl = resultData.host; // LGEITF-421
			treasuredataUrl += resultData.database+ '/'
			treasuredataUrl += resultData.table+ '?'
			treasuredataUrl += 'td_write_key='+resultData.apikey;
			treasuredataUrl += '&td_client_id='+td_client_id_cookie;
			treasuredataUrl += '&td_global_id='+td_global_id;
			treasuredataUrl += '&td_ssc_id='+td_ssc_id;
		
			// LGEITF-182 Start
			if(resultData.timeSuccess)
				treasuredataUrl += '&time_success='+resultData.timeSuccess;
			if(resultData.typeSuccess)
				treasuredataUrl += '&type_success='+resultData.typeSuccess;
			if(resultData.typeLogin)
				treasuredataUrl += '&type_login='+resultData.typeLogin;
			if(resultData.typeSocial)
				treasuredataUrl += '&type_social='+resultData.typeSocial;
			if(resultData.lgeId)
				treasuredataUrl += '&lge_id='+resultData.lgeId;
			if(resultData.tdEmail)
				treasuredataUrl += '&email='+resultData.tdEmail;
			if(resultData.tdPhone)
				treasuredataUrl += '&phone='+resultData.tdPhone;
			if(resultData.nameFirst)
				treasuredataUrl += '&name_first='+resultData.nameFirst;
			if(resultData.nameLast)
				treasuredataUrl += '&name_last='+resultData.nameLast;
			if(resultData.sodialIdTwitter)
				treasuredataUrl += '&social_id_twitter='+resultData.sodialIdTwitter;
			if(resultData.screenNameTwitter)
				treasuredataUrl += '&screen_name_twitter='+resultData.screenNameTwitter;
			if(resultData.socialIdFb)
				treasuredataUrl += '&social_id_fb='+resultData.socialIdFb;
			if(resultData.nameFullFb)
				treasuredataUrl += '&name_full_fb='+resultData.nameFullFb;
			if(resultData.typeLoginResult)
				treasuredataUrl += '&type_login_result='+resultData.typeLoginResult;
			if(resultData.failMessage)
				treasuredataUrl += '&type_fail_reason='+resultData.failMessage;
			if(resultData.localeCode)
				treasuredataUrl += '&locale_code='+resultData.localeCode;
			if(resultData.corporationCode)
				treasuredataUrl += '&corporation_code='+resultData.corporationCode;
			if(resultData.cdpNameCode)
				treasuredataUrl += '&cdp_name_code='+resultData.cdpNameCode;
			if(resultData.cdpName)
				treasuredataUrl += '&cdp_name='+resultData.cdpName;
			if(resultData.tdTypeFail)
				treasuredataUrl += '&type_fail='+resultData.tdTypeFail;
			if(resultData.noPhoneNameReason)
				treasuredataUrl += '&no_phone_name_reason='+resultData.noPhoneNameReason;
			if(resultData.socialIdEtc && resultData.typeSocial)
				treasuredataUrl += '&social_id_'+ resultData.typeSocial.toLowerCase() + '=' + resultData.socialIdEtc;
			// LGEITF-182 End

		if(cookieA && treasureDataFlag == 'Y'){
			$.ajax({
			    url : treasuredataUrl,
			    type : 'POST',
			    dataType : 'jsonp',
				jsonpCallback: "callback",
				async: false,
			    crossDomain: true,
			    beforeSend: function (xhr) {
					xhr.setRequestHeader("Content-type","application/json");
					xhr.setRequestHeader("X-TD-Write-Key",resultData.apikey);
				},
			    success : function(data){
//					console.log(data);
					console.log('treasuredata post success'); // LGEIN-239
				}
			});
		}

		
		//LGEGMC-4064 start
		var treasuredataInsertParam = "";
		if(resultData.apikey)
			treasuredataInsertParam += 'td_write_key='+encodeURIComponent(resultData.apikey);
		if(td_client_id_cookie)
			treasuredataInsertParam += '&td_client_id='+encodeURIComponent(td_client_id_cookie);
		if(td_global_id)
			treasuredataInsertParam += '&td_global_id='+encodeURIComponent(td_global_id);
		if(td_ssc_id)
			treasuredataInsertParam += '&td_ssc_id='+encodeURIComponent(td_ssc_id);
		if(resultData.timeSuccess)
			treasuredataInsertParam += '&time_success='+encodeURIComponent(resultData.timeSuccess);
		if(resultData.typeSuccess)
			treasuredataInsertParam += '&type_success='+encodeURIComponent(resultData.typeSuccess);
		if(resultData.typeLogin)
			treasuredataInsertParam += '&type_login='+encodeURIComponent(resultData.typeLogin);
		if(resultData.typeSocial)
			treasuredataInsertParam += '&type_social='+encodeURIComponent(resultData.typeSocial);
		if(resultData.lgeId)
			treasuredataInsertParam += '&lge_id='+encodeURIComponent(resultData.lgeId);
		if(resultData.tdEmail)
			treasuredataInsertParam += '&email='+encodeURIComponent(resultData.tdEmail);
		if(resultData.tdPhone)
			treasuredataInsertParam += '&phone='+encodeURIComponent(resultData.tdPhone);
		if(resultData.nameFirst)
			treasuredataInsertParam += '&name_first='+encodeURIComponent(resultData.nameFirst);
		if(resultData.nameLast)
			treasuredataInsertParam += '&name_last='+encodeURIComponent(resultData.nameLast);
		if(resultData.sodialIdTwitter)
			treasuredataInsertParam += '&social_id_twitter='+encodeURIComponent(resultData.sodialIdTwitter);
		if(resultData.screenNameTwitter)
			treasuredataInsertParam += '&screen_name_twitter='+encodeURIComponent(resultData.screenNameTwitter);
		if(resultData.socialIdFb)
			treasuredataInsertParam += '&social_id_fb='+encodeURIComponent(resultData.socialIdFb);
		if(resultData.nameFullFb)
			treasuredataInsertParam += '&name_full_fb='+encodeURIComponent(resultData.nameFullFb);
		if(resultData.typeLoginResult)
			treasuredataInsertParam += '&type_login_result='+encodeURIComponent(resultData.typeLoginResult);
		if(resultData.failMessage)
			treasuredataInsertParam += '&type_fail_reason='+encodeURIComponent(resultData.failMessage);
		if(resultData.localeCode)
			treasuredataInsertParam += '&locale_code='+encodeURIComponent(resultData.localeCode);
		if(resultData.corporationCode)
			treasuredataInsertParam += '&corporation_code='+encodeURIComponent(resultData.corporationCode);
		if(resultData.cdpNameCode)
			treasuredataInsertParam += '&cdp_name_code='+encodeURIComponent(resultData.cdpNameCode);
		if(resultData.cdpName)
			treasuredataInsertParam += '&cdp_name='+encodeURIComponent(resultData.cdpName);
		if(resultData.tdTypeFail)
			treasuredataInsertParam += '&type_fail='+encodeURIComponent(resultData.tdTypeFail);
		if(resultData.noPhoneNameReason)
			treasuredataInsertParam += '&no_phone_name_reason='+encodeURIComponent(resultData.noPhoneNameReason);
		if(resultData.socialIdEtc && resultData.typeSocial)
			treasuredataInsertParam += '&social_id_'+ resultData.typeSocial.toLowerCase() + '=' + encodeURIComponent(resultData.socialIdEtc);
		if(resultData.database)
			treasuredataInsertParam += '&td_database='+encodeURIComponent(resultData.database);
		if(resultData.table)
			treasuredataInsertParam += '&td_table='+encodeURIComponent(resultData.table);
		treasureDataInsertTable(treasuredataInsertParam);
		//LGEGMC-4064 end
	}
	function nvl(str, defaultStr){
		var check = str+"";
		var result = "";
		check = check.trim()
		if(check=="" || check==null || check == "null" || check=="undefined"){
			result = defaultStr;
		}else{
			result = check;
		}
		return result ;
	}
	// LGEUK-124 End
	
	//LGCOMITF-123-2 start
	function nonTreasureDataInsertTable(resultData){
		//LGEGMC-4064 start
		var treasuredataInsertParam = "";
		
		//Treasure Data 미사용국가들로 인해 해당데이터는 공백으로 넘겨짐. EDL 에서도 로그인 이력이 필요할뿐 Td 관련된 데이터는 필요 없음.
		treasuredataInsertParam += 'td_write_key='+encodeURIComponent('N/A');
		treasuredataInsertParam += '&td_client_id='+encodeURIComponent('N/A');
		treasuredataInsertParam += '&td_global_id='+encodeURIComponent('N/A');
		treasuredataInsertParam += '&td_ssc_id='+encodeURIComponent('N/A');
		
		if(resultData.timeSuccess)
			treasuredataInsertParam += '&time_success='+encodeURIComponent(resultData.timeSuccess);
		if(resultData.typeSuccess)
			treasuredataInsertParam += '&type_success='+encodeURIComponent(resultData.typeSuccess);
		if(resultData.typeLogin)
			treasuredataInsertParam += '&type_login='+encodeURIComponent(resultData.typeLogin);
		if(resultData.typeSocial)
			treasuredataInsertParam += '&type_social='+encodeURIComponent(resultData.typeSocial);
		if(resultData.lgeId)
			treasuredataInsertParam += '&lge_id='+encodeURIComponent(resultData.lgeId);
		if(resultData.tdEmail)
			treasuredataInsertParam += '&email='+encodeURIComponent(resultData.tdEmail);
		if(resultData.tdPhone)
			treasuredataInsertParam += '&phone='+encodeURIComponent(resultData.tdPhone);
		if(resultData.nameFirst)
			treasuredataInsertParam += '&name_first='+encodeURIComponent(resultData.nameFirst);
		if(resultData.nameLast)
			treasuredataInsertParam += '&name_last='+encodeURIComponent(resultData.nameLast);
		if(resultData.sodialIdTwitter)
			treasuredataInsertParam += '&social_id_twitter='+encodeURIComponent(resultData.sodialIdTwitter);
		if(resultData.screenNameTwitter)
			treasuredataInsertParam += '&screen_name_twitter='+encodeURIComponent(resultData.screenNameTwitter);
		if(resultData.socialIdFb)
			treasuredataInsertParam += '&social_id_fb='+encodeURIComponent(resultData.socialIdFb);
		if(resultData.nameFullFb)
			treasuredataInsertParam += '&name_full_fb='+encodeURIComponent(resultData.nameFullFb);
		if(resultData.typeLoginResult)
			treasuredataInsertParam += '&type_login_result='+encodeURIComponent(resultData.typeLoginResult);
		if(resultData.failMessage)
			treasuredataInsertParam += '&type_fail_reason='+encodeURIComponent(resultData.failMessage);
		if(resultData.localeCode)
			treasuredataInsertParam += '&locale_code='+encodeURIComponent(resultData.localeCode);
		if(resultData.corporationCode)
			treasuredataInsertParam += '&corporation_code='+encodeURIComponent(resultData.corporationCode);
		if(resultData.cdpNameCode)
			treasuredataInsertParam += '&cdp_name_code='+encodeURIComponent(resultData.cdpNameCode);
		if(resultData.cdpName)
			treasuredataInsertParam += '&cdp_name='+encodeURIComponent(resultData.cdpName);
		if(resultData.tdTypeFail)
			treasuredataInsertParam += '&type_fail='+encodeURIComponent(resultData.tdTypeFail);
		if(resultData.noPhoneNameReason)
			treasuredataInsertParam += '&no_phone_name_reason='+encodeURIComponent(resultData.noPhoneNameReason);
		if(resultData.socialIdEtc && resultData.typeSocial)
			treasuredataInsertParam += '&social_id_'+ resultData.typeSocial.toLowerCase() + '=' + encodeURIComponent(resultData.socialIdEtc);
		if(resultData.database)
			treasuredataInsertParam += '&td_database='+encodeURIComponent(resultData.database);
		if(resultData.table)
			treasuredataInsertParam += '&td_table='+encodeURIComponent(resultData.table);
		treasureDataInsertTable(treasuredataInsertParam);
		//LGEGMC-4064 end
	}
	//LGCOMITF-123-2 end
	
	// PJTGPEMP-1 Start
	function getParameterByName(name) {
	    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
	    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
	        results = regex.exec(location.search);
	    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
	}
	// PJTGPEMP-1 End
	
	// EMP 20220124 START 박지영 - Sign in 디자인 변경
	const simpleLayer = {
		init: function() {
			// copy content
			$('.layer-simple').each(function() {
				const contentId = $(this).data('content');
				if(contentId) {	
					const  html = $('#'+contentId).html();
					$(this).find('.layer-content').html(xssfilter(html, true));
				}
			});
			// button event
			const $toggleBtn = $('.js-toggle-simplelayer');
			$toggleBtn.off().on('click', function() {
				event.preventDefault();
				const layerid = $(this).attr('aria-controls');
				const $layer = $('#' + layerid);
				// show the layer
				$('.layer-simple').removeClass('active');
				$layer.addClass('active');
				const layerHeight = parseInt($layer.outerHeight()) + 40;
				const windowHeight = $(window).height();
				if(layerHeight > windowHeight) {
					$layer.addClass('full');
				}
				$('body').addClass('modal-open');
				// set top-arrow's position
				const layerPosLeft = $(this).offset().left + ($(this).width()/2) - $layer.offset().left;
				$layer.find('.arrow-top').css({
					left: layerPosLeft
				});
				$layer.find('button.close').off().on('click', function() {
					$layer.removeClass('active');
					$layer.removeClass('full');
					$('body').removeClass('modal-open');
				});
			});
		}
	};
	simpleLayer.init();
	const controlLabel = {
		el: null,
		inputs: null,
		init: function() {
			this.el = $('.signin-wrap.signin-emp');
			if(this.el.length == 0) return false;
			this.inputs = this.el.find('.common-sign-in-area .field-block').find('>input, select');
			this.runEvent();
			this.bindEvent();
		},
		changeClass: function(el) {
			if(el.val() != '' && el.get(0).value != '' ) {
				el.addClass('inputted');
			} else {
				el.removeClass('inputted');
			}
		},
		runEvent: function() {
			this.inputs.each(function() {
				//console.log($(this), $(this).val());
				controlLabel.changeClass($(this));
			});
		},
		bindEvent: function() {
			this.inputs.on('keyup input', function() {
				controlLabel.changeClass($(this));
			});
		}
	};
	controlLabel.init();
	const snsMoreBtn = {
		el: null,
		init: function() {
			this.el = $('.signin-wrap.signin-emp .sns-area-more button.more');
			this.bindEvent();
		},
		bindEvent: function() {
			this.el.on('click', function(event) {
				event.preventDefault();
				$('.sns-area').addClass('active');
			});
		}
	};
	snsMoreBtn.init();
	const noticeMore = {
		el: null,
		btn: null,
		init: function() {
			this.el = $('.signin-wrap.signin-emp .notice-area.more-info');
			this.btn = this.el.find('button.more');
			if(this.el.length === 0) return false;
			const noticeWidth = parseInt(this.el.outerWidth());
			const textWidth = parseInt(this.el.find('.notice').outerWidth());
			const btnWidth = parseInt(this.btn.outerWidth());
			// console.log(noticeWidth, textWidth, btnWidth);
			if(noticeWidth >= (textWidth + btnWidth + 10)) {
				this.el.addClass('active');
			} else {
				this.bindEvent();
			}
		},
		bindEvent: function() {
			const self = this;
			self.btn.on('click', function(event) {
				event.preventDefault();
				self.el.addClass('active');
			});
		}
	};
	noticeMore.init();
	// EMP 20220124 END 박지영

});